// extracted by mini-css-extract-plugin
module.exports = {"view":"Home3CategoryView_view__v6vMR"};